import styled from "styled-components";

export const MusicHallAccountingContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 22px;
  }
  .booking_deleted_layout {
    margin-top: 32px;
    .booking_deleted_title {
      margin-bottom: 4px;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .booking_deleted_desc {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
  }
  .button_status {
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    column-gap: 20px;
    .update_button {
      width: 130px;
    }
    .status_info_row {
      display: flex;
      column-gap: 50px;
    }
  }
`;
